export default __webpack_public_path__ + "static/media/Mortend-Regular.80d24fc4.woff2";